import { makeObservable } from 'mobx';

import { DictionaryParams } from 'chaika-frontend-types/frontend-cms';
import { DictionaryItemStatus, Locale } from 'chaika-enums';

import { SimpleList } from '@store/models/SimpleList';

export class DictionaryList extends SimpleList<DictionaryParams, string> {
    constructor(params?: DictionaryParams[]) {
        super(params);
        makeObservable(this);

        this.filterParams = '';
    }
    public get activeValues(): DictionaryParams[] {
        return this.values.filter(params => params.status === DictionaryItemStatus.Active);
    }

    public getByValue(value: string): DictionaryParams {
        const [item] = this.getFilteredValues(value);
        return item;
    }

    public getTranslationTitle(id: string, locale: Locale): string {
        const item = this.get(id);

        return item?.titleTranslations?.find(it => it.locale === locale)?.title ?? item?.title ?? '';
    }

    protected filterValue({ title, value, titleTranslations = [] }: DictionaryParams, filterParams: string): boolean {
        return Boolean(
            (title &&
                (title.toLocaleLowerCase().includes(filterParams.toLocaleLowerCase()) ||
                    titleTranslations.some(translation =>
                        translation.title.toLocaleLowerCase().includes(filterParams.toLocaleLowerCase()),
                    ))) ||
            (value && value.toLocaleLowerCase().includes(filterParams.toLocaleLowerCase())),
        );
    }
}
